import { Globe } from 'lucide-react';

import { DOCIcon, PDFIcon } from '@labradorsports/assets';
import { DocumentTypes } from '@labradorsports/constants';

interface Props {
    document: any;
}

const DocumentIcon: FC<Props> = ({ document }) => {
    const getIconByFilename = (filename: string) => (filename.endsWith('.pdf') ? PDFIcon : DOCIcon);

    if (document.type === DocumentTypes.FILE) {
        const Component = getIconByFilename(document.fileName);
        return <Component className="document-icon" />;
    }

    return document.previewImage ? <img src={document.previewImage} className="document-icon" alt="" /> : <Globe />;
};

export default DocumentIcon;
